define([
    'ko'
], (ko) => {
    'use strict';

    class MiniSearchForm {

        /** @type Object */
        config = {
            autocomplete: 'off',
            minSearchLength: 3,
            suggestionDelay: 300,
            url: null
        };

        searchQuery;

        submitDisabled;

        suggestions;

        suggestionUrl;

        /**
         * @param {Object} config configuration
         */
        constructor (config) {
            Object.assign(this.config, config);
            this.searchQuery = ko.observable('');
            this.submitDisabled = ko.observable(true);
            this.suggestions = ko.observableArray([]);
            this.suggestionUrl = ko.observable('');

            // only notify subscribers that suggestionUrl has changed if "suggestionDelay" has elapsed without changes
            this.suggestionUrl.extend({
                rateLimit: {
                    method: "notifyWhenChangesStop",
                    timeout: this.config.suggestionDelay
                }
            });

            this.searchQuery.subscribe(this.onQueryChange.bind(this));
            this.suggestionUrl.subscribe(async url => {
                this.suggestions(await (await fetch(url)).json());
            });
        }

        onQueryChange (value) {
            this.suggestions([]);
            this.submitDisabled(true);
            if (value.length < parseInt(this.config.minSearchLength, 10)) {
                return;
            }
            this.submitDisabled(false);
            if (!this.config.url || this.config.url.length === 0) {
                return;
            }

            this.suggestionUrl(`${this.config.url}?q=${encodeURIComponent(value)}`);
        }
    }

    return MiniSearchForm;
});
